import React, { useState, useEffect } from 'react'
import { Divider, Switch, Tooltip, Typography } from '@arco-design/web-react'
import openIcon from 'asserts/openIcon.png'
const OpenEditor = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [token, setToken] = useState(
    'Yoo-AI.501.5Njz7PmvA7K9du36JUG7rhsngCdpuq8Q.2sq8QHXj2jxuHH3btJUV2BQuz2HegWYx/7N6zG6nQAUE3RvTpC3HffTsQeK7SpHNX.1757298294.0'
  )
  const [appID, setAppID] = useState('')
  const [safeDomain, setSafeDomain] = useState('')
  const [tableData, setTableData] = useState([
    { key: '1', feature: '生成PPT', count: '10份' },
    { key: '2', feature: '导入PPT', count: '10份' },
    { key: '3', feature: '下载PPT', count: '9份' },
    { key: '4', feature: '导入美化', count: '9份' },
    { key: '5', feature: '排版美化', count: '无限制' },
    { key: '6', feature: '在线资源', count: '无限制' },
    { key: '7', feature: 'AI图片', count: '30张' },
    { key: '8', feature: 'AI演讲稿', count: '30页' },
    { key: '9', feature: 'AI续写', count: '无限制' },
    { key: '10', feature: 'AI网页', count: '3次' }
  ])
  const [configurationData, setConfigurationData] = useState([
    {
      label: '导入PPT',
      key: 'importPPT',
      desc: '可导入本地PPT文件进行在线编辑操作',
      enabled: true
    },
    {
      label: '下载PPT',
      key: 'downloadPPT',
      desc: '将编辑的在线文档转为pptx格式文件下载',
      enabled: true
    },
    {
      label: '导入美化',
      key: 'importBeautify',
      desc: '可对用户导入的本地PPT文档进行智能美化操作',
      enabled: true
    },
    {
      label: '排版美化',
      key: 'layoutBeautify',
      desc: '对在线PPT文档进行全文、单页、配色一键排版',
      enabled: true
    },
    {
      label: '在线资源',
      key: 'onlineResource',
      desc: '可对接在线的在线图片、视频、音频素材资源',
      enabled: true
    },
    {
      label: 'AI图片',
      key: 'aiImage',
      desc: '可根据内容生成高清配图，或基于文生图的图片',
      enabled: true
    },
    {
      label: 'AI演讲稿',
      key: 'aiSpeech',
      desc: '可根据在线文档生成对应的演讲稿内容',
      enabled: true
    },
    {
      label: 'AI续写',
      key: 'aiContinueWrite',
      desc: '对指定的文本内容进行AI续写、改写、扩写等操作',
      enabled: true
    },
    {
      label: 'AI网页',
      key: 'aiWebpage',
      desc: '在网页中创建网页浏览插件',
      enabled: true
    }
  ])

  // 常量定义
  const SECURE_DOMAIN_TIP = '填入您对接地址的安全域名，以保证对接的安全性'
  const DEMONSTRATION_WEB = '演示网站'
  const DEMONSTRATION_WEB_TIP =
    '因平台限制，本应用无法内嵌演示页面，请通过外链打开演示网站进行体验。演示网站的使用不会涉及韦尼克的计费，为保证服务稳定与公平使用，演示网站对各功能设定了时间与次数限制（按账号统计）。'
  const TABLE_NAME = '时间与次数限制（仅针对演示网站）'
  const TABLE_TIPS =
    '以上限制每30分钟刷新一次，按账号统计。仅针对演示网站，Token调用将绑定韦尼克的计费。'
  const DEMONSTRATION_WEB_URL = 'https://open.chatppt.cn/'

  // 处理功能开关切换
  const handleToggle = (key) => {
    console.log('切换功能:', key)
    setConfigurationData(
      configurationData.map((item) =>
        item.key === key ? { ...item, enabled: !item.enabled } : item
      )
    )
  }
  useEffect(() => {
    // 当configurationData更新时，会执行这里的代码,发送网络请求
  }, [configurationData])

  // 处理表单提交
  const handleSubmit = (e) => {
    e.preventDefault()
    console.log('提交配置:', { token, appID, safeDomain })
    alert('配置已保存！')
  }

  return (
    <div style={styles.container}>
      <div style={styles.leftPanel}>
        <div style={styles.configSection}>
          <div style={styles.sectionTitle}>配置信息</div>
          <form onSubmit={handleSubmit} style={styles.form}>
            {/* Token 表单项 - 保持独立 */}
            <div style={styles.formItem}>
              <div style={styles.formLabel}>Token</div>
              <div style={styles.formInput}>
                <Typography.Paragraph
                  ellipsis
                  copyable
                  style={{ color: '#6e8ece', margin: 0 }}
                >
                  {token}
                </Typography.Paragraph>
              </div>
            </div>

            {/* AppID 表单项 - 保持独立 */}
            <div style={styles.formItem}>
              <div style={styles.formLabel}>AppID</div>
              <div style={styles.formInput}>
                <Typography.Paragraph
                  ellipsis
                  copyable
                  style={{ color: '#6e8ece', margin: 0 }}
                >
                  {appID}
                </Typography.Paragraph>
              </div>
            </div>

            {/* 安全域名 + 按钮 组合项 */}
            <div style={styles.formItem}>
              <div style={styles.formLabel}>
                安全域名
                <Tooltip content={SECURE_DOMAIN_TIP}></Tooltip>
              </div>
              <div style={styles.inputWithButtonContainer}>
                <input
                  type="text"
                  value={safeDomain}
                  onChange={(e) => setSafeDomain(e.target.value)}
                  style={styles.formInput}
                  placeholder="请输入安全域名"
                />
                <button type="submit" style={styles.submitButton}>
                  保存配置
                </button>
              </div>
            </div>
          </form>
        </div>

        <div style={styles.featuresSection}>
          <div style={styles.sectionTitle}>{DEMONSTRATION_WEB}</div>
          <div style={styles.demoWebContainer}>
            <div style={styles.infoText}>{DEMONSTRATION_WEB_TIP}</div>
            <div
              style={styles.infoBtn}
              onClick={() => window.open(DEMONSTRATION_WEB_URL)}
            >
              打开演示网站
            </div>
          </div>

          <Divider style={styles.divider} />

          <div style={styles.sectionTitleB}>{TABLE_NAME}</div>
          <div style={styles.tableContainer}>
            <div style={styles.tableHeaderRow}>
              <div style={styles.tableHeaderCell1}>功能</div>
              {tableData.map((item) => (
                <div key={item.key} style={styles.tableHeaderCell}>
                  {item.feature}
                </div>
              ))}
            </div>
            <div style={styles.tableRow}>
              <div style={styles.tableCellHeader}>限制</div>
              {tableData.map((item) => (
                <div key={item.key} style={styles.tableCell}>
                  {item.count}
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <i style={styles.icon}></i>
            <div style={styles.tableNote}>{TABLE_TIPS}</div>
          </div>
        </div>
      </div>
      {/* 功能配置 */}
      <div style={styles.rightPanel}>
        <div style={styles.sectionTitle}>功能配置</div>
        <div style={styles.text}>
          以下功能启用后会在编辑器中开启对应的功能入口，功能的使用会按实际调用收取费用，详情请参考产品价格
        </div>
        <div style={styles.featuresList}>
          {configurationData.map((item) => (
            <div key={item.key} style={styles.featureItem}>
              <div style={styles.featureInfo}>
                <div style={styles.featureLabel}>{item.label}</div>
                <div style={styles.featureDesc}>{item.desc}</div>
              </div>
              <Switch
                checked={item.enabled}
                onChange={() => handleToggle(item.key)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

// 优化后的样式定义
const styles = {
  // 容器样式
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: '#f9fbff',
    padding: '20px 0',
    boxSizing: 'border-box',
    display: 'flex',
    gap: '20px'
  },
  demoWebContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  // 左侧面板样式
  leftPanel: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  icon: {
    marginTop: '10px',
    display: 'inline-block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '12px',
    height: '12px',
    marginRight: '8px',
    backgroundImage: `url(${openIcon})`
  },
  // 右侧面板样式
  rightPanel: {
    width: '30%',
    backgroundColor: '#fff',
    padding: '20px',
    boxSizing: 'border-box',
    borderRadius: '4px',
    overflow: 'auto'
  },

  // 通用区块样式
  sectionTitleB: {
    marginTop: '30px',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#333'
  },

  // 通用区块样式
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#333'
  },

  // 配置区块样式
  configSection: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '12px'
  },

  // 表单样式
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px'
  },

  formItem: {
    width: '80%',
    display: 'flex',
    alignItems: 'center'
  },

  formLabel: {
    width: '72px',
    fontSize: '14px',
    color: '#666',
    display: 'flex',
    alignItems: 'center'
  },

  inputWithButtonContainer: {
    display: 'flex',
    gap: '12px', // 输入框和按钮之间的间距
    width: '90%' // 确保整体宽度与其他输入框一致
  },

  formInput: {
    flex: 1, // 让输入框自动占据剩余空间
    padding: '8px 12px',
    border: '1px solid transparent',
    borderRadius: '6px',
    backgroundColor: '#f5f5f5',
    fontSize: '14px',
    height: '36px',
    boxSizing: 'border-box',
    color: '#6e8ece'
  },

  // 按钮样式
  submitButton: {
    padding: '8px 16px',
    backgroundColor: '#165DFF',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    width: '120px'
  },

  openButton: {
    padding: '8px 16px',
    backgroundColor: '#36D399',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    width: '120px',
    marginTop: '8px'
  },

  // 功能配置区块样式
  featuresSection: {
    backgroundColor: '#fff',
    padding: '20px 20px 40px 20px',
    borderRadius: '12px',
    flex: 1,
    overflow: 'auto'
  },

  featuresList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },

  featureItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    backgroundColor: '#fff',
    borderRadius: '4px'
  },

  featureInfo: {
    flex: 1
  },

  featureLabel: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '4px'
  },
  text: {
    fontSize: '12px',
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '16px'
  },
  featureDesc: {
    fontSize: '10px',
    color: '#666',
    maxWidth: '80%'
  },
  // 右侧面板内容样式
  infoText: {
    width: '80%',
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '16px',
    padding: '0 24px'
  },
  infoBtn: {
    padding: '10px 14px',
    marginLeft: '16px',
    color: '#406eff',
    borderRadius: '4px',
    border: '1px solid #406eff',
    cursor: 'pointer',
    fontSize: '12px'
  },
  divider: {
    margin: '16px 0'
  },

  // 表格样式
  tableContainer: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    overflow: 'hidden',
    marginBottom: '12px',
    marginTop: '20px',
    border: '1px solid #eee'
  },

  tableHeaderRow: {
    display: 'flex',
    backgroundColor: '#f9f9f9',
    borderBottom: '1px solid #eee',
    textAlign: 'center'
  },

  tableHeaderCell: {
    padding: '10px 12px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#406eff',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  tableHeaderCell1: {
    padding: '10px 12px',
    fontSize: '14px',
    backgroundColor: '#f1faff',
    fontWeight: '500',
    color: '#333',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    '&:last-child': {
      borderRight: 'none'
    }
  },

  tableRow: {
    display: 'flex'
  },

  tableCellHeader: {
    padding: '10px 12px',
    fontSize: '14px',
    backgroundColor: '#f1faff',
    color: '#333',
    fontWeight: '500',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    borderBottom: '1px solid #eee'
  },

  tableCell: {
    padding: '10px 12px',
    fontSize: '14px',
    color: '#666',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    borderBottom: '1px solid #eee',
    '&:last-child': {
      borderRight: 'none'
    }
  },

  tableNote: {
    fontSize: '12px',
    color: '#999',
    marginTop: '8px'
  }
}

export default OpenEditor
